
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Section0 from "./sections/section0"
import Section1 from "./sections/section1"
import Section2 from "./sections/section2"
import Section3 from "./sections/section3"
import Section4 from "./sections/section4"
import Footer from "./sections/footer"
import Popup from "./sections/popup"
function App() {
  const parentUrl =window.location.host.indexOf("identity-v") > -1?"https://www.resound.global":""
  const [list, setList]=useState([])
  const [unlock, setUnlock]=useState([])
  useEffect(()=>{
    axios.get( parentUrl +"/api/idvecard")
    .then((res) => {
        if (res.data) {
          setList(res.data.cards);
          setUnlock(res.data.unlock)
        }

      })
      .catch((err) => {
       
      });
  },[parentUrl])

  
    
  return (
      <>
      <Section0 /> 
      {list.length>0 && <Section1 list={list} />}
      
      <Section2 />
      <Section3 />
      <Section4 unlock={unlock}/>
      <Footer />
      <Popup />
      </>
  
  );
}

export default App;

